<template>
	<div>
		<section>
			<div class="inner row5">
				<div class="title">
					<h1>데이터관리</h1>
				</div>
				<section>
					<div class="row4">
						<div class="topContent flex">
							<div class="left flex">
								<p>총 <span>{{ totalCnt+this.searchHistoryCnt}}</span>건</p>
								<p>현재 페이지 {{ currentPage }} / {{ totalPage }}</p>
								<div class="tops">
                                    <div class="tabMenu secItemMG productHistoryBtnBox">
                                        <button class="accountTabBtn" :class="{active: currentTab===0}">
                                            설문지 {{this.totalCnt}}
                                        </button>
                                        <button class="accountTabBtn" :class="{active: currentTab===1}" v-on:click="setTabChangeGo()">
                                            검색이력 {{this.searchHistoryCnt}}
                                        </button>
                                    </div>
                                </div>
							</div>
							<div>
								<input type="text" class="searchInput" v-model="searchText" @keyup.enter="onClickSearch"/>
								<input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="onClickSearch"/>
								<input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="onClickReset"/>
							</div>
						</div>
						<div class="tableContainer">
							<div class="sampleTemplate">
								<b-table
									ref="table"
									:fields="fields"
									:items="getItems"
									:per-page="perPage"
									:current-page="currentPage"
									hover
									show-empty
									empty-text="데이터가 존재하지 않습니다.">

									<template #emptyfiltered="scope">
										<h4>{{ scope.emptyFilteredText }}</h4>
									</template>

									<template #cell(INDEX)="data">
										{{ data.index + 1 }}
									</template>

										<template #cell(STATUS)="data">
												<span v-html="getStatus(data.item)"></span>
										</template>

										<template #cell(SHOW_DETAIL)="row">
											<b-button size="sm" @click="onClickShowDetail(row)" class="mr-2">
												상세보기
											</b-button>
										</template>

									</b-table>

									<b-pagination
									v-model="currentPage"
									:total-rows="totalCnt"
									:per-page="perPage"
									aria-controls="table">
									</b-pagination>
							</div>
							<DataManagementModal v-if="isShowModalSurvey" v-bind:surveyIdx='detailSurveyIdx' @modal-closed="handleModalClosed"/>
						</div>
					</div>
				</section>
			</div>
		</section>
	</div>   
</template>

<script>
import {mapActions} from 'vuex'
import {STATUS} from '@/data/survey'
import * as surveyUtil from '@/utils/surveyUtil'
import DataManagementModal from '@/components/dataManagement/ModalDataManagement'

export default {
	name: 'Home',
	components:{
		DataManagementModal
	},
	data() {
		return {
			currentTab: 0,
			perPage: 10,
			currentPage: 1,
			totalCnt: 0,
			searchHistoryCnt: 0,
			sortBy: 'IDX',
			sortDesc: false,
			searchText : "",
			fields: [
				{
					// virtual column
					key: 'ROWNUM',
					label: 'No',
					class: 'text-center'
				},
				{
					// virtual column
					key: 'STATUS',
					label: '구분',
					isActive: true,
					class: 'statusOn text-center'
				},
				{
					key: 'TITLE',
					label: '설문 제목',
					class: 'text-center'
				},
				{
					key: 'TOTAL_COUNT',
					label: '참여수',
					class: 'text-center'
				},
				{
					key: 'REGDATE',
					label: '등록일',
					class: 'text-center'
				},
				{
					// virtual column
					key: 'SHOW_DETAIL',
					label:'상세보기',
					class: 'text-center'
				}
			],
			isShowModalSurvey: false,
			detailSurveyIdx: null, // 등록: null, 수정: survey idx
			selected: []
		}
	},
	computed:{
		totalPage(){
			if(this.totalCnt == 0 ) return 1;
			else if(this.totalCnt % this.perPage == 0) return this.totalCnt/this.perPage;
			else return Math.floor(this.totalCnt/this.perPage) + 1;
		}
	},
	methods:{
		...mapActions('survey', [
			'requestList',
			'deleteSurvey'
		]),
		getItems(){
			return this.requestList({
				currentPage: this.currentPage,
				perPage: this.perPage,
				sortBy: this.sortBy,
				sortDesc: this.sortDesc,
				searchText : this.searchText
			})
			.then(response => {
				const items = response.data.items
				this.totalCnt = response.data.totalCnt;
				this.searchHistoryCnt = response.data.searchHistoryCnt;
				

				return items
			})
			.catch((error) => {
				console.log(error)
				this.$alert("알림", "설문지 조회에 실패했습니다.");
				return []
			})
		},
		getStatus(item){
			var status = surveyUtil.getStatus(item.START_DATE, item.END_DATE)
			switch(status){
				case STATUS.STANDBY:
					return '<span class="notSubmit">대기</span>'
				case STATUS.ONGOING:
					return '진행'
				case STATUS.COMPLETED:
					return '종료'
			}
		},
		onClickShowDetail(row){
			this.detailSurveyIdx = row.item.IDX
			this.isShowModalSurvey = true
		},
		onClickHead(key){
			if(key === 'SELECT'){
				if(this.selected.length == this.totalCnt){
					this.$refs.table.clearSelected()
				}
				else{
					this.$refs.table.selectAllRows()
				}
			}
		},
		onSelectRow(items){
			this.selected = items
		},
		onClickSearch(){
			this.$refs.table.refresh()
		},
		onClickReset(){
			this.perPage = 10;
			this.currentPage = 1;
			this.totalCnt = 0;
			this.sortBy = 'IDX';
			this.sortDesc = false;
			this.searchText = "";
			
			this.$refs.table.refresh()
		},
		onClickAdd(){
			this.detailSurveyIdx = null
			this.isShowModalSurvey = true
		},
		handleModalClosed(value, param){
			if(value === DataManagementModal.name){
				this.isShowModalSurvey = false

				if(param.result == true){
					this.$refs.table.refresh()
				}
			}
		},
		setTabChangeGo() {
			this.$router.push({ path:'/admin/dataHistoryManagement'});
		}
	}
}
</script>

<style scoped lang="scss">
	.sampleTemplate ::v-deep {
		@import "~bootstrap/dist/css/bootstrap.min";
		@import "~bootstrap-vue/dist/bootstrap-vue.min";
	}
</style>